import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { motion } from "framer-motion";
import InfiniteMarquee from "../components/InfiniteMarquee";
import { fadeInUp } from "../utils/animations";
// Import client images
import Image43 from "../clients/image 43.svg";
import Image44 from "../clients/image 44.svg";
import Group1261153136 from "../clients/Group 1261153136.svg";
import Group1261153135 from "../clients/Group 1261153135.svg";
import Group1261153134 from "../clients/Group 1261153134.svg";
import Group1261153133 from "../clients/Group 1261153133.svg";
import Group1261153132 from "../clients/Group 1261153132.svg";
import Group1261153131 from "../clients/Group 1261153131.svg";
import Group1261153130 from "../clients/Group 1261153130.svg";
import Group1261153129 from "../clients/Group 1261153129.svg";
import Group1261153128 from "../clients/Group 1261153128.svg";
import Group1261153127 from "../clients/Group 1261153127.svg";

const logos = [
  { image: Image43 },
  { image: Image44 },
  { image: Group1261153136 },
  { image: Group1261153135 },
  { image: Group1261153134 },
  { image: Group1261153133 },
  { image: Group1261153132 },
  { image: Group1261153131 },
  { image: Group1261153130 },
  { image: Group1261153129 },
  { image: Group1261153128 },
  { image: Group1261153127 },
];

const TrustedLogosSection = () => {
  const LogoCard = ({ logo }) => {
    return (
      <Box
        component={motion.div}
        whileHover={{ scale: 1.05, y: -4 }}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 2,
          py: 1.5,
          borderRadius: "12px",
          background: "#ffffff",
          border: "1px solid rgba(0, 0, 0, 0.08)",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
          cursor: "pointer",
          transition: "all 0.3s ease",
          "&:hover": {
            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.12)",
            borderColor: "#3567D6",
          },
        }}
      >
        <Box
          component="img"
          src={logo.image}
          alt="Client Logo"
          sx={{
            height: { xs: "40px", sm: "50px", md: "60px" },
            width: "auto",
            maxWidth: { xs: "120px", sm: "150px", md: "180px" },
            objectFit: "contain",
            display: "block",
          }}
        />
      </Box>
    );
  };

  const firstRow = logos.slice(0, 6);
  const secondRow = logos.slice(6, 12);

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 12 },
        backgroundColor: "#ffffff",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
        {/* Section Header */}
        <Box
          component={motion.div}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={fadeInUp}
          sx={{ textAlign: "center", mb: 8 }}
        >
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "28px", md: "40px" },
              fontWeight: 700,
              color: "#1D47A4",
              fontFamily: "'Poppins', sans-serif",
            }}
          >
            Trusted by Leading Healthcare Institutions
          </Typography>
        </Box>
      </Container>

      {/* Infinite Marquee - First Row (Left to Right) */}
      <Box sx={{ mb: 3 }}>
        <InfiniteMarquee direction="left" speed={30} pauseOnHover={true}>
          {firstRow.map((logo, index) => (
            <LogoCard key={index} logo={logo} />
          ))}
        </InfiniteMarquee>
      </Box>

      {/* Infinite Marquee - Second Row (Right to Left) */}
      <Box>
        <InfiniteMarquee direction="right" speed={35} pauseOnHover={true}>
          {secondRow.map((logo, index) => (
            <LogoCard key={index} logo={logo} />
          ))}
        </InfiniteMarquee>
      </Box>

      {/* Gradient Overlays for Smooth Edges */}
      <Box
        sx={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: "100px",
          background: "linear-gradient(90deg, #ffffff 0%, transparent 100%)",
          pointerEvents: "none",
          zIndex: 1,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          right: 0,
          top: 0,
          bottom: 0,
          width: "100px",
          background: "linear-gradient(270deg, #ffffff 0%, transparent 100%)",
          pointerEvents: "none",
          zIndex: 1,
        }}
      />
    </Box>
  );
};

export default TrustedLogosSection;